import React from "react";

export default function TemplateTwo() {
  return (
    <div>
      <div>Template Two</div>
    </div>
  );
}
